angular.module('acme.view.application.importExport.jobExecution.directives.importExportJobExecutionErrorGrid', [
    'acme.common.service.utils',
    'acme.common.service.userPreferences'
])
.directive('importExportJobExecutionErrorGrid', [function() {
    return {
        restrict: 'A',
        replace: true,
        scope: {
            job: '='
        },
        controller: 'importExportJobExecutionErrorGridController',
        template: '<div><div data-ng-include="\'common/views/dataGrid/dataGrid.tpl.html\'" data-scope-property="importExportJobExecutionError" data-ng-controller="DataGridController"></div></div>'
    };
}]).filter('importExportDate', ['$filter', 'UserPreferencesService', function($filter, UserPreferencesService) {
    return function(input) {
        return $filter('date')(input, UserPreferencesService.getDateTimeFormat('sortDateTime'));
    };
}]).controller( 'importExportJobExecutionErrorGridController',  [
    '$rootScope',
    '$scope',
    '$state',
    '$timeout',
    '$uibModal',
    '$document',
    'PermissionsService',
    'UtilsService',
    'ImportJobExecutionsApiService',
    'JOB_EXECUTION_ACTIVE_STATUSES',
    'JOB_EXECUTION_ERROR_CODES',
    'JOB_EXECUTION_ERROR_TYPES',
    'JOB_EXECUTION_ERROR_STATUSES',
    'JOB_EXECUTION_STATUS_TITLE',
    'JOB_EXECUTION_ERROR_MESSAGES_TYPES',
    'GridStateFactory',
    'GridDefinitionFactory', function ($rootScope, $scope, $state, $timeout, $uibModal, $document, PermissionsService, UtilsService, ImportJobExecutionsApiService, JOB_EXECUTION_ACTIVE_STATUSES, JOB_EXECUTION_ERROR_CODES, JOB_EXECUTION_ERROR_TYPES, JOB_EXECUTION_ERROR_STATUSES, JOB_EXECUTION_STATUS_TITLE, JOB_EXECUTION_ERROR_MESSAGES_TYPES, GridStateFactory, GridDefinitionFactory) {

        $scope.importExportJobExecutionError = {
            executionId: $state.params.id,
            gridName: $state.current.name+'.errors.grid',
            gridDefinition: new GridDefinitionFactory(),
            gridState: new GridStateFactory(),
            model: [],
            optionsOverride: {
                rowHeight: 30,
                data: 'importExportJobExecutionError.model',
                useAccessibleGrid: true,
                appScopeProvider: {
                    onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {
                        self.gridState.updateGridState(newPage, pageSize);
                        if (sortField) {
                            self.gridState.updateGridState(null, null, sortField, null);
                        }
                        if(sortDirection) {
                            self.gridState.updateGridState(null, null, null, sortDirection);
                        }
                        self.getErrors();
                    },
                    onDataGridSortChange: function(grid, columns, page) {
                        var data = columns[0];
                        self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
                        self.getErrors();
                    },
                    onDblClick: function (item) {
                    },

                    getErrorTypeTitle: function(type) {
                        return JOB_EXECUTION_ERROR_TYPES[type] || type;
                    },

                    getErrorCodeTitle: function(code) {
                        if (JOB_EXECUTION_ERROR_CODES[code]) {
                            return JOB_EXECUTION_ERROR_CODES[code].title;
                        }

                        return code;
                    },

                    getErrorCodeDescription: function(code) {
                        if (JOB_EXECUTION_ERROR_CODES[code]) {
                            return JOB_EXECUTION_ERROR_CODES[code].description;
                        }

                        return code;
                    },

                    getErrorStatusTitle: function(status) {
                        return JOB_EXECUTION_ERROR_STATUSES[status] || status;
                    },

                    getErrorTypeIcon: function (type) {
                      return JOB_EXECUTION_ERROR_MESSAGES_TYPES[type].class;
                    },

                    getErrorTypeIconTitle: function (type) {
                      return JOB_EXECUTION_ERROR_MESSAGES_TYPES[type].title;
                    },

                    getErrorTypeIconMessage: function (type) {
                      return JOB_EXECUTION_ERROR_MESSAGES_TYPES[type].message;
                    },

                    openPopup: function ($event, error) {
                        if (UtilsService.eventAlreadyFired($event)) {
                            return;
                        }
                        $uibModal.open({
                            templateUrl: 'jobExecutionErrorModal.html',
                            controller: ['error', function (error) {
                                this.error = error;
                            }],
                            controllerAs: '$ctrl',
                            appendTo: angular.element($document[0].querySelector('.import-export-job-execution')),
                            resolve: {
                                error: function () {
                                    return error;
                                }
                            }
                        });
                    }
                },
                columnDefs: [
                    {
                        field: 'message',
                        displayName: 'Error message',
                        name: 'message',
                        cellTemplate: '<div class="ui-grid-cell-contents" title="{{row.entity.message}}">{{row.entity.message}}</div>'
                    },
                    // {
                    //   field: 'messageErrorType',
                    //   displayName: 'Error Type',
                    //   name: 'messageErrorType',
                    //   cellTemplate: '<div class="ui-grid-cell-contents" title="{{ (grid.appScope ? grid.appScope : importExportJobExecutionError.optionsOverride.appScopeProvider).getErrorTypeIconTitle(row.entity.messageErrorType) }}">' +
                    //     '<span aria-hidden="true" class="{{ (grid.appScope ? grid.appScope : importExportJobExecutionError.optionsOverride.appScopeProvider).getErrorTypeIcon(row.entity.messageErrorType) }}"></span> {{ (grid.appScope ? grid.appScope : importExportJobExecutionError.optionsOverride.appScopeProvider).getErrorTypeIconMessage(row.entity.messageErrorType) }}' +
                    //   '</div>'
                    // },
                    {
                        field: 'row',
                        displayName: 'Row',
                        width: 60
                    },
                    {
                        field: 'createdOn',
                        displayName: 'Created On',
                        width: 80,
                        cellTemplate: '<div class="ui-grid-cell-contents">{{(row.entity.createdOn | importExportDate) || "Unavailable" }}</div>'
                    },
                    {
                        field: 'type',
                        displayName: 'type',
                        width: 80,
                        cellTemplate: '<div class="ui-grid-cell-contents">{{ (grid.appScope ? grid.appScope : importExportJobExecutionError.optionsOverride.appScopeProvider).getErrorTypeTitle(row.entity.type) }}</div>'
                    },
                    {
                        field: 'code',
                        displayName: 'code',
                        width: 80,
                        cellTemplate: '<div class="ui-grid-cell-contents">{{ (grid.appScope ? grid.appScope : importExportJobExecutionError.optionsOverride.appScopeProvider).getErrorCodeTitle(row.entity.code) }}</div>'
                    },
                    {
                        field: 'status',
                        displayName: 'status',
                        width: 80,
                        cellTemplate: '<div class="ui-grid-cell-contents">{{ (grid.appScope ? grid.appScope : importExportJobExecutionError.optionsOverride.appScopeProvider).getErrorStatusTitle(row.entity.status) }}</div>'
                    },
                    {
                        field: 'source',
                        displayName: 'source',
                        width: 80,
                        enableSorting: false,
                        cellTemplate: '<div class="ui-grid-cell-contents import-export-job-execution-view-error-source"><a data-ng-click="(grid.appScope ? grid.appScope : importExportJobExecutionError.optionsOverride.appScopeProvider).openPopup($event, row.entity.source);$event.stopPropagation();">View</a></div>'
                    }
                ]
            },

            init: function() {
                self.gridDefinition.init(this.gridName, this.optionsOverride, $state.current.name, $state.current.data.enablePreferences);

                $scope.$on('$destroy', $scope.$on('DataGrid::UserPreferencesLoaded', this.initData));
            },

            initData: function(e, data) {
                var props = self.gridDefinition.getGridState();
                self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
                self.getErrors();
            },


            getErrors: function() {
                var gridState = self.gridState.getGridState();
                var sortField = null;
                if (gridState.sortField && gridState.sortDirection) {
                    if (gridState.sortField === 'messageErrorType') {
                      gridState.sortField = 'errorType';
                    }
                    sortField = gridState.sortField + "," + gridState.sortDirection;
                }
                ImportJobExecutionsApiService.errors(self.executionId, gridState.page - 1,
                    gridState.pageSize,
                    sortField)
                    .then(self.success.getData, self.error.getData);
            },

            success: {
                getData: function (response) {
                    self.model = response.data._embedded ? response.data._embedded.jobErrorVoList : [];

                    self.gridDefinition.isLoaded = true;

                    $timeout(function() {
                        $scope.$broadcast('DataGrid::ResizeGrid', {
                            name: self.gridName,
                            datasetLength: self.model.length,
                            totalItems: response.data.page.totalElements
                        });

                    }, 10);
                }
            },

            error: {
                init: function(response) {},
                getData: function (data) {}
            }
        };

        var self = $scope.importExportJobExecutionError;

        $scope.$on('ImportExport::loadErrors', function() {
            self.getErrors();
        });

        self.init();
    }]);

